/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateMerchant} from '../api'

export const useMutationUpdateMerchant = createReactQueryMutationHook('updateMerchant', updateMerchant)
